import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Chip
} from '@mui/material';
import { formatNumber } from './formatters';

interface OperationalStatsData {
  total_documentos: number;
  total_fornecedores: number;
  total_produtos: number;
}

interface OperationalStatsLabels {
  documentos: string;
  fornecedores: string;
  produtos: string;
}

interface DrillDownOperationalStatsProps {
  data: OperationalStatsData;
  labels?: OperationalStatsLabels;
  title?: string;
}

const DrillDownOperationalStats: React.FC<DrillDownOperationalStatsProps> = ({ 
  data, 
  labels,
  title = "📊 Estatísticas Operacionais" 
}) => {
  if (!data) return null;

  const { total_documentos, total_fornecedores, total_produtos } = data;

  // Labels padrão se não fornecidos
  const defaultLabels = {
    documentos: 'Documentos',
    fornecedores: 'Fornecedores',
    produtos: 'Produtos'
  };

  const finalLabels = labels || defaultLabels;

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Chip 
          label={`${finalLabels.documentos}: ${formatNumber(total_documentos)}`}
          color="secondary"
          variant="outlined"
          size="medium"
        />
        <Chip 
          label={`${finalLabels.fornecedores}: ${formatNumber(total_fornecedores)}`}
          color="success"
          variant="outlined"
          size="medium"
        />
        <Chip 
          label={`${finalLabels.produtos}: ${formatNumber(total_produtos)}`}
          color="warning"
          variant="outlined"
          size="medium"
        />
      </Box>
    </Grid>
  );
};

export default DrillDownOperationalStats; 